import { Directive, ViewContainerRef } from '@angular/core';

@Directive({selector: '[formPlaceholder]'})
export class FormPlaceholder {
  constructor(public viewContainer: ViewContainerRef) { }
}

@Directive({selector: '[injectionPlaceholder]'})
export class InjectionPlaceholder {
  constructor(public viewContainer: ViewContainerRef) { }
}
